import { connect } from 'react-redux';
import { getUnits } from '../../../../reducers/analyticsApp';
import CreateUnitsContainer from '../../../../components/dashboards/cards/create/CreateUnitsContainer';
import { setDashboardUnit, setUnits } from '../../../../actions/dashboards/dashboards';

const mapStateToProps = (state) => ({
  units: getUnits(state),
});

const mapDispatchToProps = {
  addUnit: setDashboardUnit,
  setUnits,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateUnitsContainer);
